<div class="alert alert-{{ type() }}" role="alert">
  @if (icon) {
    <i class="fa fa-{{ icon }}"></i>
  }
  {{ message() }}
  <!-- Projected content, for a message that needs a template - a plural has to be an ICU
       expression in a template, which a string input cannot carry (ui.md, Forms). -->
  <ng-content></ng-content>
</div>
